import React, { useEffect, useState } from "react";
import "./Coupons.css";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import DoubleHeading from "../../Common-Component/DoubleHeading/DoubleHeading";
import { CouponCode } from "../../../utils/apis/master/Master";

function Coupons({ sectionId }) {
  const [couponsData, setCouponsData] = useState([]);
  useEffect(() => {
    const fetchCoupons = async () => {
      const res = await CouponCode();
      if (res?.success) {
        setCouponsData(res.data);
      }
    };
    fetchCoupons();
  }, []);

  //   const coupons = [
  //     {
  //       id: 1,
  //       code: "SAVE20",
  //       discount: "20% OFF",
  //       description: "Get 20% off on all products above ₹999.",
  //       expiry: "Valid till 30th Sept 2025",
  //     },
  //     {
  //       id: 2,
  //       code: "FREESHIP",
  //       discount: "Free Shipping",
  //       description: "Enjoy free shipping on orders above ₹499.",
  //       expiry: "Valid till 15th Oct 2025",
  //     },
  //     {
  //       id: 3,
  //       code: "BUY1GET1",
  //       discount: "Buy 1 Get 1",
  //       description: "Applicable on selected categories only.",
  //       expiry: "Valid till 10th Nov 2025",
  //     },
  //   ];

  return (
    <>
      <section className="Coupons" id={sectionId}>
        <Container fluid>
          <div className="mb-3 mt-5">
            <DoubleHeading heading={"Coupons"} />
          </div>
          <Row className="g-4">
            {couponsData.map((coupon) => (
              <Col key={coupon.id} xs={12} md={6} lg={4}>
                <Card className="coupon-card h-100 shadow-sm">
                  <Card.Body>
                    <h5 className="coupon-discount">
                      {coupon.total_amount
                        ? `₹ ${coupon.total_amount}`
                        : `${coupon.discount} %`}
                    </h5>

                    <p className="coupon-desc">{coupon.coupon_message}</p>
                    <p className="coupon-expiry text-muted small">
                      {new Date(coupon.e_date).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "long",
                        year: "numeric",
                      })}
                    </p>

                    <div className="d-flex justify-content-between align-items-center mt-3">
                      <span className="coupon-code">
                        Code: <strong>{coupon.code}</strong>
                      </span>
                      {/* <Button className="applybtn">Apply</Button> */}
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </>
  );
}

export default Coupons;
